import React, { useState, useMemo } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import PersonalAdminAsideBar from "./PersonalAdminAsideBar";

const AdminSettingsLayout = ({ title,children }) => {
  const navigate = useNavigate();
  const [showAsideBar, setShowAsideBar] = useState(false);

  // Memoize the isMobile check since it won't change during component lifecycle
  const isMobile = useMemo(() => (
    window.matchMedia?.("only screen and (max-width: 767px)").matches
  ), []);

  const handleGoBack = () => setShowAsideBar(true);

  const handlePublicProfileView = () => navigate("/public-profile");

  // Memoize the aside bar component to prevent unnecessary re-renders
  const memoizedAsideBar = useMemo(() => (
    <PersonalAdminAsideBar setShowAsideBar={setShowAsideBar} />
  ), []);

  return (
    <div className="col-span-12">
      <div className="">
        <h4 className="text-xl md:text-2xl font-bold leading-[130%] md:leading-[130%] text-[#04091E] mb-5 md:mb-[30px] hidden md:block">
          Settings
        </h4>
        <div className="flex items-center gap-[6px] mb-5 md:hidden">
          <div className="flex items-center gap-[3.5px]">
            <ArrowLeftIcon
              className="w-6 h-6 text-[#485868] cursor-pointer"
              onClick={handleGoBack}
            />
            <h3 className="text-xl font-normal leading-[130%] text-[#485868]">
              {showAsideBar && "Daniel"}
            </h3>
          </div>
          {showAsideBar && <span className="text-[#485868]">&#8226;</span>}
          <h3 className="text-xl font-bold leading-[130%] text-customGray">
            {showAsideBar ? "Settings" : title}
          </h3>
        </div>
      </div>
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-4 xl:col-span-3">
          {isMobile ? (
            showAsideBar && memoizedAsideBar
          ) : (
            memoizedAsideBar
          )}
        </div>
        <div className="col-span-12 md:col-span-8 xl:col-span-9">
          {!showAsideBar && children}
        </div>
      </div>
    </div>
  );
};

export default React.memo(AdminSettingsLayout);